<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 py-3 size">
                <v-row class="px-5 pt-5">
                    <v-col cols="12" align="center" justify="center">    
                        <h3 class="blue_accent--text text-uppercase">{{ $t('edit_role.new_role') }}</h3>
                    </v-col>
                </v-row>
                <v-card-text class="px-0">
                    <v-form ref="form" lazy-validation @submit.prevent="save">
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="8" class="py-0">
                                <v-text-field class="py-0" v-model="name" :label="$t('edit_role.name')" :rules="rules_required"></v-text-field>  
                            </v-col>
                        </v-row>

                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="8" class="py-0">
                                <v-autocomplete class="mt-0 py-0" v-model="is_for_clients" :items="types" :label="$t('edit_role.type')" item-text="text" item-value="value" :rules="rules_required"></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row class="px-5 py-0 my-0" align="center" justify="center">
                            <v-col class="py-0" cols="8" align="start" justify="center">
                                <label for="" class="blue_accent--text mt-3" style="font-weight: bold; font-size: 18px; width:100%; text-align: start">{{$t('edit_role.permissions')}}</label>  
                                <v-expansion-panels class="my-3">
                                    <v-expansion-panel v-for="(item, index) in this.permissions" :key="index">
                                        <v-expansion-panel-header class="my-0 py-0">
                                            <h4 class="blue_accent--text uppercase" >{{ item.g_name }}</h4>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <table-checkbox :props="{headers:generateHeaders(item.permissions), items: item.permissions}" @methodHandler="methodHandler"></table-checkbox>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-row class="px-5 py-0" justify="center" align="end">
                        <v-col cols="8" justify="center" align="end">
                            <v-btn class="right px-3 mx-4" @click="cancel">
                                {{ $t('create_appointment.cancel') }}
                            </v-btn>
                            <v-btn class="right white_highlight--text" color="secondary" @click="save" v-permission="'role.create'">
                                {{ $t('create_appointment.save') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
        </v-container>
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>

import { rolesShowUseCase } from '../application/use_cases/roles_show_use_case'
import { rolesUpdateUseCase } from '../application/use_cases/roles_update_use_case';
import { HttpRoleRepository } from '../infrastructure/repositories/role_repository';

export default {
    computed: {
        rules_required() {return [v => !!v || this.$t('create_appointment.validations.required_field')]}, 
    },
    data() {
        return {
            id: this.$route.params.id,
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            name: "",
            is_for_clients: false,
            types: [{ text: this.$t('create_user.admin'), value: false }, { text: this.$t('create_user.customer'), value: true }],
            shipping_services: ["fedex", "merq", "ups", "usps", "otra", 'afimex', "tiui", "vencedor", "ihs", "qualitypost"],
            permissions: [
                { g_name: this.$t("edit_role.headers.general"), permissions: [
                    { value: this.$t('edit_role.headers.dashboard'), concept: "dashboard", all: false, create: null, view: false, edit: null, delete: null, manage_stores: null },
                    { value: this.$t('edit_role.headers.yego_bi'), concept: "yego_bi", all: false, create: null, view: false, edit: null, delete: null, manage_stores: null },
                    { value: this.$t('edit_role.headers.client'), concept: "client", all: false, create: false, view: false, edit: false, delete: false, manage_stores: false },
                    { value: this.$t('edit_role.headers.relocation'), concept: "relocation", all: false, create: false, view: false, edit: null, delete: null, manage_stores: null },
                    { value: this.$t('edit_role.headers.relocation_with_scanner'), concept: "relocation_with_scanner", all: false, create: false, view: false, edit: null, delete: null, manage_stores: null },
                    { value: this.$t('edit_role.headers.operation'), concept: "operation", all: false, create: null, view: false, edit: false, delete: null, manage_stores: null },
                ]},
                { g_name: this.$t("edit_role.headers.special"), permissions: [
                    { value: this.$t('edit_role.headers.create_damaged'), concept: "damaged", create: false },
                    { value: this.$t('edit_role.headers.create_refurbish'), concept: "refurbish", create: false },
                    { value: this.$t('edit_role.headers.create_massive_products'), concept: "massive_products", create: false },
                    { value: this.$t('edit_role.headers.customer_fees'), concept: "customer_fees", create: false },
                    { value: this.$t('edit_role.headers.guides_fees'), concept: "guides_fees", create: false },
                    { value: this.$t('edit_role.headers.basic_search'), concept: "basic_search", create: false },
                    { value: this.$t('edit_role.headers.generate_epcs'), concept: "generate_epcs", create: false },
                    { value: this.$t('edit_role.headers.update_batch_reference'), concept: "update_batch_reference", create: false },
                    { value: this.$t('edit_role.headers.backlog'), concept: "backlog", create: false },
                    { value: this.$t('edit_role.headers.release_aff_orders'), concept: "release_aff_orders", create: false }
                ]},
                { g_name: this.$t("edit_role.headers.inventory"), permissions: [
                    { value: this.$t('edit_role.headers.category'), concept: "category", all: false, create: false, view: false, edit: false, delete: false },
                    { value: this.$t('edit_role.headers.product'), concept: "product", all: false, create: false, view: false, edit: false, delete: false },
                    { value: this.$t('edit_role.headers.kit'), concept: "kit", all: false, create: false, view: false, edit: false, delete: false }
                ]},
                { g_name: this.$t("edit_role.headers.national_appointment"), permissions: [
                    { value: this.$t('edit_role.headers.n_pending'), concept: "n_pending", all: false, create: false, view: false, edit: false, file: false, delete: false },
                    { value: this.$t('edit_role.headers.n_processed'), concept: "n_processed", all: false, create: false, view: false, edit: false, file: false, delete: false },
                    { value: this.$t('edit_role.headers.n_pdf'), concept: "n_pdf", all: null, create: null, view: false, edit: null, file: null, delete: null }
                ]},
                { g_name: this.$t("edit_role.headers.international_appointment"), permissions: [
                    { value: this.$t('edit_role.headers.i_pending'), concept: "i_pending", all: false, create: false, view: false, edit: false, delete: false, file: false, validate: null },
                    { value: this.$t('edit_role.headers.i_without_annex'), concept: "i_without_annex", all: false, create: false, view: false, edit: false, delete: false, file: false, validate: null },
                    { value: this.$t('edit_role.headers.i_processed'), concept: "i_processed", all: false, create: false, view: false, edit: false, delete: false, file: false, validate: false },
                    { value: this.$t('edit_role.headers.i_digital_heritage'), concept: "i_digital_heritage", all: false, create: null, view: false, edit: null, delete: null, file: false, validate: null },
                    { value: this.$t('edit_role.headers.i_pdf'), concept: "i_pdf", all: null, create: null, view: false, edit: null, delete: null, file: null, validate: null },
                    { value: this.$t('edit_role.headers.i_multiple'), concept: "i_multiple", all: null, create: false, view: null, edit: null, delete: null, file: null, validate: null }
                ]},
                { g_name: this.$t("edit_role.headers.appointment_operation"), permissions: [
                    { value: this.$t('edit_role.headers.op_pendings'), concept: "op_pendings", all: false, view: false, edit: false },
                    { value: this.$t('edit_role.headers.op_on_premises'), concept: "op_on_premises", all: false, view: false, edit: false },
                    { value: this.$t('edit_role.headers.op_in_process'), concept: "op_in_process", all: false, view: false, edit: false },
                    { value: this.$t('edit_role.headers.op_pending_out'), concept: "op_pending_out", all: false, view: false, edit: false },
                ]},
                { g_name: this.$t("edit_role.headers.compliance"), permissions: [
                    { value: this.$t('edit_role.headers.i_without_annex'), concept: "c_without_annex", all: false, create: false, view: false, edit: false, delete: false, file: false, validate: null },
                    { value: this.$t('edit_role.headers.i_processed'), concept: "c_processed", all: false, create: false, view: false, edit: false, delete: false, file: false, validate: false },
                    { value: this.$t('edit_role.headers.i_digital_heritage'), concept: "c_digital_heritage", all: false, create: null, view: false, edit: null, delete: null, file: false, validate: null },
                ]},
                { g_name: this.$t("edit_role.headers.guides"), permissions: [
                    { value: this.$t('edit_role.headers.guides'), concept: "guides", all: false, create: false, view: false, edit: false, delete: false, refresh: false },
                ]},
                { g_name: this.$t("edit_role.headers.reports"), permissions: [
                    { value: this.$t('edit_role.headers.stock'), concept: "stock", view: false },
                    { value: this.$t('edit_role.headers.operations_by_client'), concept: "operations_by_client", view: false },
                    { value: this.$t('edit_role.headers.operations_by_product'), concept: "operations_by_product", view: false },
                    { value: this.$t('edit_role.headers.international_operations'), concept: "international_operations", view: false },
                    { value: this.$t('edit_role.headers.products_by_fulfillment'), concept: "products_by_fulfillment", view: false },
                    { value: this.$t('edit_role.headers.products_by_order'), concept: "products_by_order", view: false },
                    { value: this.$t('edit_role.headers.annex_documents'), concept: "annex_documents", view: false },
                    { value: this.$t('edit_role.headers.history_product'), concept: "history_product", view: false },
                    { value: this.$t('edit_role.headers.cod_by_shipping_service'), concept: "cod_by_shipping_service", view: false },
                    { value: this.$t('edit_role.headers.fulfillment_summary'), concept: "fulfillment_summary", view: false },
                    { value: this.$t('edit_role.headers.balance_pallet'), concept: "balance_pallet", view: false },
                    { value: this.$t('edit_role.headers.boxes_per_fulfillment'), concept: "boxes_per_fulfillment", view: false },
                    { value: this.$t('edit_role.headers.condensed_fulfillment'), concept: "condensed_fulfillment", view: false },
                ]},
                { g_name: this.$t("edit_role.headers.catalog"), permissions: [
                    { value: this.$t('edit_role.headers.warehouse'), concept: "warehouse", all: false, create: false, view: false, edit: false, delete: false },
                    { value: this.$t('edit_role.headers.location'), concept: "location", all: false, create: false, view: false, edit: false, delete: false },
                    { value: this.$t('edit_role.headers.gate'), concept: "gate", all: false, create: false, view: false, edit: false, delete: false },
                    { value: this.$t('edit_role.headers.box'), concept: "box", all: false, create: false, view: false, edit: false, delete: false },
                    { value: this.$t('edit_role.headers.customs_broker'), concept: "customs_broker", all: false, create: false, view: false, edit: false, delete: false },
                    { value: this.$t('edit_role.headers.origin_supplier'), concept: "origin_supplier", all: false, create: false, view: false, edit: false, delete: false },
                    { value: this.$t('edit_role.headers.services'), concept: "services", all: false, create: false, view: false, edit: false, delete: null },
                    { value: this.$t('edit_role.headers.consumables'), concept: "consumables", all: false, create: false, view: false, edit: false, delete: false },
                    { value: this.$t('edit_role.headers.stations'), concept: "stations", all: false, create: false, view: false, edit: false, delete: false },
                    { value: this.$t('edit_role.headers.slots'), concept: "slots", all: false, create: false, view: false, edit: false, delete: false },
                    { value: this.$t('edit_role.headers.totes'), concept: "totes", all: false, create: false, view: false, edit: false, delete: false },
                ]},
                { g_name: this.$t("edit_role.headers.yego_services"), permissions: [
                    { value: this.$t('edit_role.headers.advanced_search'), concept: "search", view: false },
                    { value: this.$t('edit_role.headers.cod_collection'), concept: "cod_collection", view: false },
                    { value: this.$t('edit_role.headers.collection'), concept: "collection", view: false },
                    { value: this.$t('edit_role.headers.administrative_history'), concept: "administrative_history", view: false },
                    { value: this.$t('edit_role.headers.operative_history'), concept: "operative_history", view: false },
                    { value: this.$t('edit_role.headers.balance'), concept: "balance", view: false },
                    { value: this.$t('edit_role.headers.balancev2'), concept: "balancev2", view: false },
                    { value: this.$t('edit_role.headers.balancev3'), concept: "balancev3", view: false },
                    { value: this.$t('edit_role.headers.balancev4'), concept: "balancev4", view: false },
                    { value: this.$t('edit_role.headers.returned_billing'), concept: "returned_billing", view: false },
                    { value: this.$t('edit_role.headers.products_summary'), concept: "products_summary", view: false },
                    { value: this.$t('edit_role.headers.yego_update_order_status'), concept: "yego_update_order_status", view: false },
                    { value: this.$t('edit_role.headers.odoo_report'), concept: "odoo_report", view: false },
                    { value: this.$t('edit_role.headers.paypal_update_order_status'), concept: "paypal_update_order_status", view: false },
                    { value: this.$t('edit_role.headers.paypal_orders_report'), concept: "paypal_orders_report", view: false },
                    { value: this.$t('edit_role.headers.create_shipments'), concept: "shipment", view: false },
                    { value: this.$t('edit_role.headers.create_multiple_orders'), concept: "create_multiple_orders", view: false },
                    { value: this.$t('edit_role.headers.shipping_guides_payments'), concept: "shipping_guides_payments", view: false },
                    { value: this.$t('edit_role.headers.history_shipping_guides'), concept: "history_shipping_guides", view: false },
                    { value: this.$t('edit_role.headers.balance_shipping_guides'), concept: "balance_shipping_guides", view: false },
                    { value: this.$t('edit_role.headers.shipments_comments'), concept: "shipments_comments", view: false },
                ]},
                { g_name: this.$t("edit_role.headers.track_n_trace"), permissions: [
                    { value: this.$t('edit_role.headers.extra_status'), concept: "extra_status", view: false },
                    { value: this.$t('edit_role.headers.daily_cutoff'), concept: "daily_cutoff", view: false },
                    { value: this.$t('edit_role.headers.closing_minute'), concept: "closing_minute", view: false },
                    { value: this.$t('edit_role.headers.without_movement'), concept: "without_movement", view: false },
                    { value: this.$t('edit_role.headers.rejections'), concept: "rejections", view: false },
                    { value: this.$t('edit_role.headers.delivered'), concept: "delivered", view: false },
                ]},
                { g_name: this.$t("edit_role.headers.bonded_warehouse"), permissions: [
                    { value: this.$t('edit_role.headers.customs_operator'), concept: "customs_operator", view: false },
                    { value: this.$t('edit_role.headers.customs_administrator'), concept: "customs_administrator", view: false },
                    { value: this.$t('edit_role.headers.new_annex_24'), concept: "new_annex_24", view: false },
                ]},
                { g_name: this.$t("edit_role.headers.customers"), permissions: [
                    { value: this.$t('edit_role.headers.customer'), concept: "customer", view: false },
                    { value: this.$t('edit_role.headers.customer_fulfillment'), concept: "customer_fulfillment", view: false },
                    { value: this.$t('edit_role.headers.advanced_customer_fulfillment'), concept: "advanced_customer_fulfillment", view: false },
                    { value: this.$t('edit_role.headers.customer_fulfillment_eon'), concept: "customer_fulfillment_eon", view: false },
                    { value: this.$t('edit_role.headers.customer_all_access'), concept: "customer_all_access", view: false },
                    { value: this.$t('edit_role.headers.customer_sedsa'), concept: "customer_sedsa", view: false },
                    { value: this.$t('edit_role.headers.customer_guides_d2i'), concept: "customer_guides_d2i", view: false },
                    { value: this.$t('edit_role.headers.customer_guides_b2c'), concept: "customer_guides_b2c", view: false },
                ]},
                { g_name: this.$t("edit_role.headers.orders_pendings"), permissions: [
                    { value: this.$t('edit_role.headers.orders_pendings'), concept: "orders_pendings", all: false, view: false, edit: false, delete: false },
                    { value: this.$t('edit_role.headers.orders_possible_fraud'), concept: "orders_possible_fraud", all: false, view: false, edit: false, delete: false },
                    { value: this.$t('edit_role.headers.stuck_external_orders'), concept: "stuck_external_orders", all: false, view: false, edit: null, delete: false },
                ]},
                { g_name: this.$t("edit_role.headers.customs_patch"), permissions: [
                    { value: this.$t('edit_role.headers.customs_patch'), concept: "customs_patch", all: false, view: false, create: false, delete: false },
                ]},
                { g_name: this.$t("edit_role.headers.mobile"), permissions: [
                    { value: this.$t('edit_role.headers.cyclical_inventory'), concept: "cyclical_inventory", all: false, create: false, view: false, edit: null, finalize: null },
                    { value: this.$t('edit_role.headers.radar'), concept: "radar", all: null, create: null, view: false, edit: null, finalize: null },
                    { value: this.$t('edit_role.headers.fulfillment_evidence'), concept: "ff_evidence", all: false, create: false, view: false, edit: null, finalize: null },
                    { value: this.$t('edit_role.headers.rfid_inventory'), concept: "rfid_inventory", all: false, create: false, view: false, edit: false, finalize: false }
                ]},
                { g_name: this.$t("edit_role.headers.rfid"), permissions: [
                    { value: this.$t('edit_role.headers.rfid_simulate'), concept: "rfid", simulate: false },
                ]},
                { g_name: this.$t("edit_role.headers.entrance"), permissions: [
                    { value: this.$t('edit_role.headers.visitors'), concept: "visitors", all: false, create: false, view: false, edit: false, delete: false, qr: false, gafete: false },
                    { value: this.$t('edit_role.headers.carriers'), concept: "carriers", all: false, create: false, view: false, edit: false, delete: false, qr: null, gafete: null },
                    { value: this.$t('edit_role.headers.attendances'), concept: "attendances", all: false, create: false, view: false, edit: null, delete: false, qr: null, gafete: null },
                ]},
                { g_name: this.$t("edit_role.headers.access"), permissions: [
                    { value: this.$t('edit_role.headers.role'), concept: "role", all: false, create: false, view: false, edit: false, delete: false },
                    { value: this.$t('edit_role.headers.user'), concept: "user", all: false, create: false, view: false, edit: false, delete: false },
                ]},
                { g_name: this.$t("edit_role.headers.paycash"), permissions: [
                    { value: this.$t('edit_role.headers.paycash_reference'), concept: "paycash_reference", all: false, view: false, create: false, import: false, export: false },
                    { value: this.$t('edit_role.headers.paycash_cod'), concept: "paycash_cod", all: false, view: false, create: false, import: false, export: false },
                    { value: this.$t('edit_role.headers.paycash_cod_comments'), concept: "paycash_cod_comments", all: false, create: false },
                    { value: this.$t('edit_role.headers.minutes'), concept: "minutes", view: false },
                    { value: this.$t('edit_role.headers.billing'), concept: "billing", view: false },
                    { value: this.$t('edit_role.headers.payment_pending'), concept: "payment_pending", view: false },
                    { value: this.$t('edit_role.headers.orders_identifier'), concept: "orders_identifier", view: false },
                    { value: this.$t('edit_role.headers.products_by_category'), concept: "products_by_category", view: false },
                    { value: this.$t('edit_role.headers.cod_collection'), concept: "cod_collection", view: false },
                    { value: this.$t('edit_role.headers.balance'), concept: "balance", view: false },
                    { value: this.$t('edit_role.headers.history'), concept: "history", view: false }
                ]},
            ]
        }
    },
    mounted() {
        this.index();
        this.$store.state.module = "headers.edit_role";
        var count = 7;
        this.shipping_services.forEach(x => {
            this.permissions.splice(count, 0, { g_name: this.$t("edit_role.headers.fulfillment_" + x), permissions: [
                { value: this.$t('edit_role.headers.cod_order'), concept: x + "_cod_order", all: false, process: false, view: false, edit: false, restore: null },
                { value: this.$t('edit_role.headers.pending_cod'), concept: x + "_pending_cod", all: false, process: null, view: false, edit: null, restore: false },
                { value: this.$t('edit_role.headers.processed_cod'), concept: x + "_processed_cod", all: false, process: null, view: false, edit: null, restore: false, },
                { value: this.$t('edit_role.headers.cod_returned'), concept: x + "_cod_returned", all: false, process: false, view: false, edit: null, restore: false },
                { value: this.$t('edit_role.headers.regular_order'), concept: x + "_regular_order", all: false, process: false, view: false, edit: false, restore: null },
                { value: this.$t('edit_role.headers.pending_regular'), concept: x + "_pending_regular", all: false, process: null, view: false, edit: null, restore: false },
                { value: this.$t('edit_role.headers.processed_regular'), concept: x + "_processed_regular", all: false, process: null, view: false, edit: null, restore: false },
                { value: this.$t('edit_role.headers.regular_returned'), concept: x + "_regular_returned", all: false, process: false, view: false, edit: null, restore: false },
                { value: this.$t('edit_role.headers.advanced_fulfillment'), concept: x + "_advanced_fulfillment", all: false, process: false, view: false, edit: false, restore: null },
                { value: this.$t('edit_role.headers.ptl_fulfillment'), concept: x + "_ptl_fulfillment", all: false, process: false, view: false, edit: false, restore: null },
            ]})
            count++;
        })
        this.permissions.splice(count, 0, { g_name: this.$t("edit_role.headers.fulfillment_eon"), permissions:[
            { value: this.$t("edit_role.headers.pendings"), concept: "eon_pendings", all: false, process: false, view: false, edit: false, restore: null, create: null },
            { value: this.$t("edit_role.headers.in_process"), concept: "eon_in_process", all: false, process: null, view: false, edit: null, restore: false, create: null },
            { value: this.$t("edit_role.headers.sent"), concept: "eon_sent", all: false, process: null, view: false, edit: null, restore: false, create: null },
            { value: this.$t("edit_role.headers.returned"), concept: "eon_returned", all: false, process: false, view: false, edit: null, restore: false, create: null },
            { value: this.$t("edit_role.headers.advanced_fulfillment"), concept: "eon_advanced_fulfillment", all: false, process: false, view: false, edit: false, restore: null, create: null },
            { value: this.$t("edit_role.headers.create_with_label"), concept: "eon_create_with_label", all: false, process: null, view: null, edit: null, restore: null, create: false }
        ]})

        this.permissions.forEach((perm) => {
            
            // Watch for customers
            if(perm.g_name == this.$t("edit_role.headers.customers")) {
                perm.permissions.forEach((sub_p) => {
                    this.$watch(
                        () => sub_p.view,
                        (newVal) => {
                            perm.permissions.forEach( y => {
                                if(
                                    y.concept != sub_p.concept 
                                    && newVal == true 
                                    && (perm.permissions.findIndex(i => i.concept == y.concept) < perm.permissions.findIndex(j => j.concept == sub_p.concept))) {
                                    y.view = false; 
                                }
                            })
                        }
                    )
                })
            }

            // Watch for 'all' variables
            perm.permissions.forEach((sub_p) => {
                this.$watch(
                    () => sub_p.all,
                    (newVal) => {
                        Object.keys(sub_p).forEach( x => {
                            if(sub_p[x] != undefined && x != 'value' && x != 'concept') sub_p[x] = newVal;
                        })
                    }
                )
            })
        })
    },
    methods: {
        async index() {
            try{
                const role = await rolesShowUseCase(this.id, HttpRoleRepository);
    
                this.name = role.data.success.arguments.name;
                this.is_for_clients = role.data.success.arguments.is_for_clients;
                
                this.permissions.forEach( group => {
                    const map = Object.fromEntries(group.permissions.map(obj => [obj.concept, obj]));                    

                    role.data.success.arguments.permissions.forEach( flag => {
                        flag = flag.name;
                        const [concept, prop] = flag.split(".");

                        if(map[concept] != undefined){
                            if (map[concept] && prop in map[concept]) {
                                map[concept][prop] = true;
                            }
                            else {
                                if((prop == "index" || prop == "show") && "view" in map[concept]) map[concept]["view"] = true;
                                if((prop == "update") && "edit" in map[concept]) map[concept]["edit"] = true;
                            }
                        }
                    })
                });

            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }            
        },
        methodHandler(object) {
            this[object.methodName](object.parameters);
        },
        cancel() {
            this.$router.go(-1);
        },
        generateHeaders(items) {
            const omitKeys = ['concept'];
            
            return Object.keys(items[0])
                .filter(key => !omitKeys.includes(key))
                .map((key) => ({
                text: key === "value" ? '' : this.$t('edit_role.headers.' + key),
                value: key,
                class: 'text-uppercase',
                align: key === 'value' ? 'start' : 'end',
                width: key === 'value' ? '40%' : undefined
            }));
        },
        async save() {
            const IGNORE = ["value", "concept", "name", "all"];
            var permissions = this.permissions.flatMap(group => 
                group.permissions.flatMap(item => 
                    Object.entries(item)
                    .filter(([key, value]) => !IGNORE.includes(key) && value === true)
                    .map(([key]) => `${item.concept}.${key}`)
                )
            )

            const p_result = permissions.map(item => ({ name: item }));

            if(this.name == "" || p_result.length == 0) {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t("edit_role.name_and_permissions_required")
                }
                
                return;
            }

            try{
                const result = await rolesUpdateUseCase(this.id, { name: this.name, permissions: p_result, is_for_clients: this.is_for_clients }, HttpRoleRepository);
                result;
                this.cancel();            
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        }
    }
}
</script>

<style lang="css">
</style>